// SCL brand assets
export const SCL_LOGO_WORDMARK_HORIZONTAL =
  "https://customer-assets-0z36b82j.emergentagent.net/job_scl-kindness/artifacts/6382qm3g_SCL-final-logo-clearspace-namelogo-cropped%20%282%29.png";

export const SCL_LOGO_FULL_STACKED =
  "https://customer-assets-0z36b82j.emergentagent.net/job_scl-kindness/artifacts/1csiafnz_SCL-final-logo-clearspace-all-01.png";

export const SCL_FLOWER_MARK =
  "https://customer-assets-0z36b82j.emergentagent.net/job_scl-kindness/artifacts/gnr10cww_SCL%20Logo_Flower%20Only%20%282%29.jpg";

// Community/outdoor/kids-in-action imagery (Unsplash, curated by design agent)
export const HERO_COMMUNITY =
  "https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxkaXZlcnNlJTIwaGFwcHklMjBraWRzJTIwc2Nob29sJTIwY29tbXVuaXR5fGVufDB8fHx8MTc4NDE1NzA0Nnww&ixlib=rb-4.1.0&q=85";

export const HERO_KIDS_LEARNING =
  "https://images.unsplash.com/photo-1533222535026-754c501569dd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwyfHxkaXZlcnNlJTIwaGFwcHklMjBraWRzJTIwc2Nob29sJTIwY29tbXVuaXR5fGVufDB8fHx8MTc4NDE1NzA0Nnww&ixlib=rb-4.1.0&q=85";

export const HERO_OUTDOOR_ACTION =
  "https://images.unsplash.com/photo-1533222481259-ce20eda1e20b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxjb21tdW5pdHklMjBzZXJ2aWNlJTIwa2lkcyUyMHBsYXlpbmd8ZW58MHx8fHwxNzg0MTU3MDQ2fDA&ixlib=rb-4.1.0&q=85";

export const HERO_OUTDOOR_NATURE =
  "https://images.unsplash.com/photo-1469406396016-013bfae5d83e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwzfHxjb21tdW5pdHklMjBzZXJ2aWNlJTIwa2lkcyUyMHBsYXlpbmd8ZW58MHx8fHwxNzg0MTU3MDQ2fDA&ixlib=rb-4.1.0&q=85";

// Difficulty -> hero image mapping for challenge cards
export function heroForChallenge(challenge) {
  const d = challenge?.difficulty;
  if (d === "Easy") return HERO_KIDS_LEARNING;
  if (d === "Medium") return HERO_OUTDOOR_ACTION;
  if (d === "Go Big") return HERO_COMMUNITY;
  return HERO_OUTDOOR_NATURE;
}
